/* tslint:disable */
/* eslint-disable */
export enum VpnProtocol {
  Udp = 'UDP',
  Tcp = 'TCP'
}
